const tryGetLocalStorage = (key) => {
	if(typeof window !== 'undefined' && window.localStorage){
		return window.localStorage.getItem(key);
	} else {
		return '';
	}
}

const tryGetProcessEnv = (key) => {
	if(typeof process !== 'undefined'){
		return process.env[key];
	} else {
		return '';
	}
}

export const getAPIPath = (relpath) => {
	const api_base = tryGetLocalStorage('apiBase') || tryGetProcessEnv('API_BASE') || '/api/';
	const extension = tryGetLocalStorage('apiExt');
	const path = api_base + relpath;
	return (extension !== null) ? (path + extension) : path ;
}

export const getMediaPath = (relpath) => {
	const media_base = tryGetLocalStorage('mediaBase') || tryGetProcessEnv('MEDIA_BASE') || false;
	return (media_base) ? (media_base + relpath) : relpath;
}


// WEBPACK FOOTER //
// ./src/utils/environment.jsx